import { axiosBase, errorHandler } from "./axios";

const bulkInsertRoutes = (input: any) => {
    return axiosBase
        .post("/api/v1/routes/bulk-insert-routes", input)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
}

const updateRoutes = (input: any) => {
    return axiosBase
        .post("/api/v1/routes/update", input)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
}

export const routeService = {
    bulkInsertRoutes, updateRoutes
};